import React from "react";
import PlayerStatsInformation from "../../../Content/PlayerCard/PlayerStatsInformation/PlayerStatsInformation";
import PlayerInformation from "../../../Content/PlayerCard/PlayerInformation/PlayerInformation";
import Summary from "../Summary/Summary";
import GameLog from "../GameLog/GameLog";
import News from "../News/News";
import SingleCardComponent from "../../../Content/PlayerCard/SingleCard/SingleCard";
function InfoComponentTop(props) {
  const player_information = props.player_information_props;
  const player_stats_information = props.player_stats_information;
  const player_season_stats = props.player_season_stats;

  const [navSelectedTab, setNavSelectedTab] = React.useState("Summary");

  const changeActiveState = function (summary, gamelog, news) {
    if (summary) {
      document.getElementById("summary").classList.add("btn-dark");
      document.getElementById("gamelog").classList.remove("btn-dark");
      // document.getElementById("news").classList.remove("btn-dark");
    } else if (gamelog) {
      document.getElementById("summary").classList.remove("btn-dark");
      document.getElementById("gamelog").classList.add("btn-dark");
      // document.getElementById("news").classList.remove("btn-dark");
    } else if (news) {
      document.getElementById("summary").classList.remove("btn-dark");
      document.getElementById("gamelog").classList.remove("btn-dark");
      // document.getElementById("news").classList.add("btn-dark");
    }
  };
  return (
    <>
      <div className="pb-2 bg-dark border-bottom">
        <SingleCardComponent
          key={player_information.OperatorPlayerID}
          player_info={player_information}
          show_lock_exclude={false}
        />
        {/* Navbar for Summary Game Logs and News Starts Here */}
        <div className="d-flex justify-content-center pt-3 pb-2">
          <ul className="nav nav-pills bg-secondary rounded p-1">
            <li className="nav-item">
              <button
                className="btn nav-link btn-dark text-white"
                id="summary"
                onClick={() => {
                  setNavSelectedTab("Summary");
                  changeActiveState(true, false, false);
                }}
              >
                Summary
              </button>
            </li>
            <li
              style={{ display: props.league === "ASIACUP" ? "none" : "block" }}
              className="nav-item"
            >
              <button
                className="btn nav-link text-white"
                id="gamelog"
                onClick={() => {
                  setNavSelectedTab("Game Log");
                  changeActiveState(false, true, false);
                }}
              >
                Game Log
              </button>
            </li>
          </ul>
        </div>
        {/* Navbar Ends */}
      </div>
      {navSelectedTab === "Summary" && (
        <Summary
          player_season_stats={player_season_stats}
          player_position={props.player_information_props.Position}
          player_actual_season_stats={props.player_actual_season_stats}
          player_stats={props.player_stats_information}
          actual_player_data_available={props.actual_player_data_available}
          league={props.gameInformationReducer.sports}
          rcConfig={props.rcConfig}
        />
      )}
      {navSelectedTab === "Game Log" && (
        <GameLog
          player_actual_season_stats={props.player_actual_season_stats}
          gamelogs={props.gamelogs}
          player_position={props.player_information_props.Position}
          player_teamname={props.player_teamname}
          gameInformationReducer={props.gameInformationReducer}
          league={props.gameInformationReducer.sports}
          rcConfig={props.rcConfig}
        />
      )}
      {navSelectedTab === "News" && <News />}
    </>
  );
}

export default InfoComponentTop;
